if (!customElements.get('quick-add-modal')) {
  // July 2026: fast quick-add — hover/touch prefetch, in-memory cache,
  // Section Rendering API (fetch only the product section instead of the full page),
  // and idle warm-up of the first products on the page.
  var QuickAddPrefetchCache = new Map();
  var QuickAddLoadedScripts = new Set();
  var QuickAddSectionId = null;
  try { QuickAddSectionId = sessionStorage.getItem('quickAddSectionId'); } catch (e) {}

  var quickAddExtractSectionId = function (text) {
    var m = text.match(/id="MainProduct-(template--[^"]+)"/);
    return m ? m[1] : null;
  };

  var quickAddFetchProduct = function (url) {
    if (QuickAddSectionId) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return fetch(url + sep + 'section_id=' + QuickAddSectionId)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          if (text.indexOf('id="MainProduct-') === -1) {
            // The id went stale - a theme update renames the template's
            // section - and nothing cleared it, so every warm-up asked for a
            // page that 404s and then fetched the whole product anyway, twice
            // the requests for the rest of the session. Forget it and learn
            // the new one from the full page.
            QuickAddSectionId = null;
            try { sessionStorage.removeItem('quickAddSectionId'); } catch (e) {}

            return fetch(url)
              .then(function (r) { return r.text(); })
              .then(function (full) {
                var sid = quickAddExtractSectionId(full);
                if (sid) {
                  QuickAddSectionId = sid;
                  try { sessionStorage.setItem('quickAddSectionId', sid); } catch (e) {}
                }
                return full;
              });
          }
          return text;
        });
    }
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var sid = quickAddExtractSectionId(text);
        if (sid) {
          QuickAddSectionId = sid;
          try { sessionStorage.setItem('quickAddSectionId', sid); } catch (e) {}
        }
        return text;
      });
  };

  var quickAddPrefetch = function (url) {
    if (!url || QuickAddPrefetchCache.has(url)) return;
    QuickAddPrefetchCache.set(url, quickAddFetchProduct(url).catch(function (e) { QuickAddPrefetchCache.delete(url); throw e; }));
  };

  var quickAddPrefetchHandler = function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('button[data-product-url][data-modal]') : null;
    if (btn) quickAddPrefetch(btn.getAttribute('data-product-url'));
  };
  document.addEventListener('pointerover', quickAddPrefetchHandler, { passive: true });
  document.addEventListener('touchstart', quickAddPrefetchHandler, { passive: true });

  var quickAddIdleSeed = function () {
    var openers = Array.prototype.slice.call(document.querySelectorAll('button[data-product-url][data-modal]'), 0, 4);
    if (!openers.length) return;
    var firstUrl = openers[0].getAttribute('data-product-url');
    quickAddPrefetch(firstUrl);
    var first = QuickAddPrefetchCache.get(firstUrl) || Promise.resolve();
    first.catch(function () {}).then(function () {
      openers.slice(1).forEach(function (btn) { quickAddPrefetch(btn.getAttribute('data-product-url')); });
    });
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(quickAddIdleSeed, { timeout: 4000 });
  } else {
    setTimeout(quickAddIdleSeed, 2500);
  }

  // July 2026: prefetch product sections as their cards scroll into view.
  // This is the key win on mobile (no hover) — by the time you tap, it's cached.
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var conn = navigator.connection || {};
    if (conn.saveData) return;
    if (conn.effectiveType && /(^|-)2g$/.test(conn.effectiveType)) return;
    var MAX_PREFETCH = 60;
    var DWELL_MS = 250;
    var prefetchedCount = 0;
    var timers = new WeakMap();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var btn = entry.target;
        if (entry.isIntersecting) {
          if (timers.has(btn)) return;
          var tid = setTimeout(function () {
            timers.delete(btn);
            if (prefetchedCount >= MAX_PREFETCH) { io.unobserve(btn); return; }
            var url = btn.getAttribute('data-product-url');
            if (url && !QuickAddPrefetchCache.has(url)) { prefetchedCount++; quickAddPrefetch(url); }
            io.unobserve(btn);
          }, DWELL_MS);
          timers.set(btn, tid);
        } else {
          if (timers.has(btn)) { clearTimeout(timers.get(btn)); timers.delete(btn); }
        }
      });
    }, { rootMargin: '300px 0px' });
    var observeAll = function () {
      document.querySelectorAll('button[data-product-url][data-modal]').forEach(function (btn) {
        if (!btn.dataset.qaObserved) { btn.dataset.qaObserved = '1'; io.observe(btn); }
      });
    };
    observeAll();
    // Catch cards added later (filtering / infinite scroll / pagination).
    var rescan = null;
    var mo = new MutationObserver(function () {
      if (rescan) return;
      rescan = setTimeout(function () { rescan = null; observeAll(); }, 400);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();

  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // July 2026: open the modal immediately with a spinner for instant feedback
      this.modalContent.innerHTML = '<div class="quick-add-modal__loading" style="display:flex;align-items:center;justify-content:center;min-height:24rem;"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width:3.6rem;height:3.6rem;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
      super.show(opener);

      const productUrl = opener.getAttribute('data-product-url');
      if (!QuickAddPrefetchCache.has(productUrl)) quickAddPrefetch(productUrl);
      (QuickAddPrefetchCache.get(productUrl) || quickAddFetchProduct(productUrl))
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
        })
        .catch(() => {
          this.hide(true);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        // July 2026: skip re-loading external scripts that already ran on this page
        const extSrc = oldScriptTag.getAttribute('src');
        if (extSrc) {
          if (QuickAddLoadedScripts.has(extSrc)) {
            oldScriptTag.remove();
            return;
          }
          QuickAddLoadedScripts.add(extSrc);
        }
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}
